import { Routes, Route, Navigate } from 'react-router-dom';
import { AdminLayout } from './components/layout/AdminLayout';
import { AuthGuard } from './components/guards/AuthGuard';
import { Dashboard } from './pages/dashboard/Dashboard';
import { TenantList } from './pages/tenants/TenantList';
import { TenantDetail } from './pages/tenants/TenantDetail';
import { BillingDashboard } from './pages/billing/BillingDashboard';
import { SubscriptionList } from './pages/billing/SubscriptionList';
import { InvoiceList } from './pages/billing/InvoiceList';
import { InvoiceDetail } from './pages/billing/InvoiceDetail';
import { FailedPayments } from './pages/billing/FailedPayments';
import { PlanList } from './pages/plans/PlanList';
import { PlanTenants } from './pages/plans/PlanTenants';
import { PlatformAnalytics } from './pages/analytics/PlatformAnalytics';
import { PlatformReports } from './pages/reports/PlatformReports';
import { AuditLog } from './pages/monitoring/AuditLog';
import { SystemSettings } from './pages/system/SystemSettings';
import { QueueMonitor } from './pages/system/QueueMonitor/index';
import { UserAccessManagement } from './pages/system/UserAccessManagement';
import { Login } from './pages/auth/Login';
import { OrderList } from './pages/orders/OrderList';
import { OrderDetail } from './pages/orders/OrderDetail';
import { MisaDashboard } from './pages/misa/MisaDashboard';
import { MisaJobDetail } from './pages/misa/MisaJobDetail';
import { NotificationTemplateList } from './pages/notification-template/NotificationTemplateList';
import { NotificationTemplateForm } from './pages/notification-template/NotificationTemplateForm';
import { MenuList } from './pages/menu/MenuList';
import { MenuEdit } from './pages/menu/MenuEdit';
import { ZaloZnsTemplateList } from './pages/zalo-zns-template/ZaloZnsTemplateList';
import { ZaloZnsTemplateEdit } from './pages/zalo-zns-template/ZaloZnsTemplateEdit';
import { ZaloZnsTemplateView } from './pages/zalo-zns-template/ZaloZnsTemplateView';
import { EmailTemplateList } from './pages/email-template/EmailTemplateList';
import { EmailTemplateEdit } from './pages/email-template/EmailTemplateEdit';
import { SupportTickets } from './pages/support/SupportTickets';
// EG-52 — Tổ chức & CRM
import { StaffList } from './pages/staffs/StaffList';
import { StaffDetail } from './pages/staffs/StaffDetail';
import { StoreList } from './pages/stores/StoreList';
import { StoreDetail } from './pages/stores/StoreDetail';
import { CustomerList } from './pages/customers/CustomerList';
import { CustomerDetail } from './pages/customers/CustomerDetail';
import { VoucherList } from './pages/vouchers/VoucherList';
import { VoucherDetail } from './pages/vouchers/VoucherDetail';
import { BankList } from './pages/banks/BankList';
import { BankDetail } from './pages/banks/BankDetail';
import { BidvList } from './pages/bidv/BidvList';
import { BidvDetail } from './pages/bidv/BidvDetail';
import { PageList } from './pages/content/pages/PageList';
import { PageForm } from './pages/content/pages/PageForm';
import { ArticleList } from './pages/content/articles/ArticleList';
import { ArticleForm } from './pages/content/articles/ArticleForm';
import { ArticleCategoryList } from './pages/content/article-categories/ArticleCategoryList';

function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/" element={<AuthGuard><AdminLayout /></AuthGuard>}>
        <Route index element={<Navigate to="/dashboard" replace />} />
        <Route path="dashboard" element={<Dashboard />} />

        {/* Tenant Routes */}
        <Route path="tenants" element={<TenantList />} />
        <Route path="tenants/:id" element={<TenantDetail />} />

        {/* Order Routes */}
        <Route path="orders" element={<OrderList />} />
        <Route path="orders/:id" element={<OrderDetail />} />

        {/* MISA Routes */}
        <Route path="misa" element={<MisaDashboard />} />
        <Route path="misa/:tenantId/:jobType" element={<MisaJobDetail />} />

        {/* Billing Routes */}
        <Route path="billing" element={<BillingDashboard />} />
        <Route path="billing/subscriptions" element={<SubscriptionList />} />
        <Route path="billing/invoices" element={<InvoiceList />} />
        <Route path="billing/invoices/:id" element={<InvoiceDetail />} />
        <Route path="billing/failed-payments" element={<FailedPayments />} />

        {/* Plans Routes */}
        <Route path="plans" element={<PlanList />} />
        <Route path="plans/:id/tenants" element={<PlanTenants />} />

        {/* Analytics Routes */}
        <Route path="analytics" element={<PlatformAnalytics />} />

        {/* Reports Routes */}
        <Route path="reports" element={<PlatformReports />} />

        {/* Monitoring Routes */}
        <Route path="monitoring/audit" element={<AuditLog />} />

        {/* Support Routes */}
        <Route path="support/tickets" element={<SupportTickets />} />

        {/* System Routes */}
        <Route path="system/accounts" element={<UserAccessManagement />} />
        <Route path="system/settings" element={<SystemSettings />} />
        <Route path="system/queues" element={<QueueMonitor />} />

        {/* Menu Routes */}
        <Route path="menu" element={<MenuList />} />
        <Route path="menu/add" element={<MenuEdit />} />
        <Route path="menu/:id/edit" element={<MenuEdit />} />

        {/* Notification Template Routes */}
        <Route path="notification-templates" element={<NotificationTemplateList />} />
        <Route path="notification-templates/add" element={<NotificationTemplateForm />} />
        <Route path="notification-templates/:id/edit" element={<NotificationTemplateForm />} />

        {/* Zalo ZNS Template Routes */}
        <Route path="zalo-zns-templates" element={<ZaloZnsTemplateList />} />
        <Route path="zalo-zns-templates/add" element={<ZaloZnsTemplateEdit />} />
        <Route path="zalo-zns-templates/:id/edit" element={<ZaloZnsTemplateEdit />} />
        <Route path="zalo-zns-templates/:id/view" element={<ZaloZnsTemplateView />} />

        {/* Email Template Routes */}
        <Route path="email-templates" element={<EmailTemplateList />} />
        <Route path="email-templates/add" element={<EmailTemplateEdit />} />
        <Route path="email-templates/:id/edit" element={<EmailTemplateEdit />} />

        {/* EG-52 — Tổ chức & CRM */}
        <Route path="staffs" element={<StaffList />} />
        <Route path="staffs/:id" element={<StaffDetail />} />
        <Route path="stores" element={<StoreList />} />
        <Route path="stores/:id" element={<StoreDetail />} />
        <Route path="customers" element={<CustomerList />} />
        <Route path="customers/:id" element={<CustomerDetail />} />
        <Route path="vouchers" element={<VoucherList />} />
        <Route path="vouchers/:id" element={<VoucherDetail />} />
        <Route path="banks" element={<BankList />} />
        <Route path="banks/:id" element={<BankDetail />} />
        <Route path="bidv-refund-banks" element={<BidvList />} />
        <Route path="bidv-refund-banks/:id" element={<BidvDetail />} />

        {/* Content Routes */}
        <Route path="content/pages" element={<PageList />} />
        <Route path="content/pages/add" element={<PageForm />} />
        <Route path="content/pages/:id/edit" element={<PageForm />} />
        <Route path="content/articles" element={<ArticleList />} />
        <Route path="content/articles/add" element={<ArticleForm />} />
        <Route path="content/articles/:id/edit" element={<ArticleForm />} />
        <Route path="content/article-categories" element={<ArticleCategoryList />} />
      </Route>
    </Routes>
  );
}

export default App;
